import { useIntl } from 'react-intl'
import Modal from 'LuxKit/Modal/Modal'
import FlexibleCancellationPolicyTimelineModalWithoutDates from './FlexibleCancellationPolicyTimelineModalWithoutDates'
import FlexibleCancellationPolicyModalWithDates from './FlexibleCancellationPolicyModalWithDates'

export interface Props {
  today: moment.Moment
  checkInDate?: string | moment.Moment
  startBasedOnToday: moment.Moment
  startBasedOnCheckIn: moment.Moment | undefined
  cancellationAfterChangeOfMindPeriod: boolean
  days: number
  /** Whether this is a charter bundle (flights + hotel). Affects terminology and shows charter-specific fees. */
  isCharter?: boolean
}

function OfferPropertyFlexibleCancellationPolicyTimelineModal(props: Props) {
  const {
    today,
    checkInDate,
    startBasedOnToday,
    startBasedOnCheckIn,
    cancellationAfterChangeOfMindPeriod,
    days,
    isCharter,
  } = props

  const intl = useIntl()
  const hasDates = !!checkInDate && !!startBasedOnCheckIn

  return (
    <Modal
      title={intl.formatMessage({
        id: 'ip9FOw9dQ_KIKaoEbQDw',
        defaultMessage: 'Cancellation policy',
        description: 'Title for flexible cancellation policy modal in the cancellation flow',
      })}
    >
      <div>
        {hasDates && checkInDate && startBasedOnCheckIn && (
          <FlexibleCancellationPolicyModalWithDates
            today={today}
            checkInDate={checkInDate}
            startBasedOnToday={startBasedOnToday}
            startBasedOnCheckIn={startBasedOnCheckIn}
            cancellationAfterChangeOfMindPeriod={cancellationAfterChangeOfMindPeriod}
            isCharter={isCharter}
          />
        )}
        {!hasDates && (
          <FlexibleCancellationPolicyTimelineModalWithoutDates
            days={days}
            isCharter={isCharter}
          />
        )}
      </div>
    </Modal>
  )
}

export default OfferPropertyFlexibleCancellationPolicyTimelineModal
